<style>
  .ivu-modal-footer{border: none;}
  .ivu-select-multiple{height: 32px;}
  .ivu-select-selection{z-index:100;}
</style>
<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query" label-position="top">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="学生姓名" prop="studentName">
                <Input
                  v-model="query.studentName"
                  clearable
                  placeholder="请输入学生姓名"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="学生身份证" prop="studentIdCardNum">
                <Input
                  v-model="query.studentIdCardNum"
                  clearable
                  placeholder="请输入学生身份证"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="申请原因" prop="deleteReason">
                <Input
                  v-model="query.deleteReason"
                  clearable
                  placeholder="请输入申请原因"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="报名年级" prop="enrollmentGrade">
                <Select v-model="query.enrollmentGrade" clearable>
                  <Option
                    v-for="item in typeList"
                    :key="item.index"
                    :value="item.type"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="学校机构" prop="schoolType">
                <Select v-model="query.schoolType" clearable>
                  <Option
                    v-for="item in schoolIspubliclist"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
               <form-item label="入学时间" prop="admissionDate">
                 <DatePicker type="year" v-model="admissionDate" placeholder="请选择入学时间" style="display:flex"/>
               </form-item>
             </i-col>
             <i-col span="6">
               <form-item label="申请时间" prop="admissionDates">
                  <DatePicker type="datetimerange" v-model="admissionDates" format="yyyy-MM-dd" placeholder="请选择申请时间"/>
               </form-item>
             </i-col>
          </row>
        </i-form>
      </div>
      <div class="table-data ">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader"
            :border="true"
            :loading="isLoading"
            :data="tableData"
            stripe
            ref="table"
            @on-selection-change="handleSelect"
          >
            <template slot-scope="{ row, index }" slot="action">
              <span @click="handleClickDetail(row, 'detail')" class="action">[详情]</span>
             <Poptip
                transfer
                confirm
                title="确认删除?"
                placement="left"
                @on-ok="handleClickDetail(row, 'del')"
              >
                <span class="action">[删除]</span>
              </Poptip>
              <!-- <span class="action" @click="handleClickDetail(row, 'audit')">[审核]</span> -->
            </template>

          </i-table>
        </div>

        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            :page-size="pageSize"
            :page-size-opts="pagesizeopts"
            @on-change="pageChange"
            show-total
            show-sizer
            @on-page-size-change="onpagesizechange"
          />
        </div>
      </div>


    </div>
    <Modal v-model="delmodel" width="360">
        <p slot="header" style="color:#f60;text-align:center">
            <Icon type="ios-information-circle"></Icon>
            <span>删除确认</span>
        </p>
        <div style="text-align:center">
            <p>是否确认删除所勾选学生信息？</p>
        </div>
        <div slot="footer">
            <Button type="info" @click="hidedelmodel">取消</Button>
            <Button type="success"  @click="handleAllDelete">删除</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import miment from "miment";
import pageHead from "../../../components/head";
import api from "../../../api/index";
const {
 selectApplicationDeleteInfo,deleteAllInfoByStudentId,educationPermissionCheck,pseudoDeleteAllInfoList
} = api;

export default {
  name: "pleasedel",
  components: {
    pageHead,
  },

  data() {
    return {
      schoolIspubliclist:[
        {index: 1,type: "公办"},
        {index: 2,type: "民办"},
      ],
      delmodel:false,
      iseducation:true,
      typeList: [
        {index: 1,type: "小一"},
        {index: 2,type: "初一"},
        {index: 3,type: "五升六"},
      ],
      showopen:false,
      useList: [
        {index: 0,type: "待办理"},
        {index: 1,type: "办理成功"},
      ],
      admissionDate: '',
      admissionDates: '',
      query: {
        "studentName":"",
        "studentIdCardNum":"",
        "enrollmentGrade":"",
        deleteReason: '',
        "schoolType":"",
        beginTime: "",
        endTime: '',
        upbeginTime: '',
        upendTime: ''
      },
      isLoading: false,
      isBtbLoading: false,
      pageNum: 1,
      pageSize: 50,
      pagesizeopts:[50,100,150,200],
      total: 0,
      title: "申请删除学生",
      btnList: [
        {name: "搜索",type: "search"},
        {name: "重置",type: "refsh"},
        {name: "批量删除",type: "del"},
      ],
      tableHeader: [
          {type: "selection",width:70,align: "center",},
          {title: "学生姓名",key: "studentName"},
          {title: "学生身份证",key: "studentIdCardNum"},
          {title: "学校机构",key: "schoolType"},
          {title: "报名年级",key: "enrollmentGrade"},
          {title: "申请原因",key: "deleteReason"},
          {title: "操作",slot: "action"},
      ],
      tableData: [],
      selectedList:[],
      selectedListid:[],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  watch: {
    admissionDate(newVal, oldVal){
      this.query.beginTime = miment(newVal).format()
      this.query.endTime = miment(newVal).add(+11,'MM').add(+30,'DD').format('YYYY-MM-DD ') + '23:59:59'
      console.log(this.query.beginTime)
      console.log(this.query.endTime)
    },
    admissionDates(newVal, oldVal){
      console.log(newVal)
      this.query.upbeginTime = miment(newVal[0]).format()
      this.query.upendTime = miment(newVal[1]).format("YYYY-MM-DD ") + '23:59:59'
      console.log(this.query.upbeginTime)
      console.log(this.query.upendTime)
    }
  },
  methods: {
    open(){
      this.showopen=!this.showopen
    },
    onpagesizechange(e){
      this.pageSize=e
      this.pageNum = 1;
      this.getinfo()
    },
    handleBtn(type) {
      if (type == "search") {
        this.pageNum = 1;
        this.getinfo()
      }
      else if (type == "refsh"){
        this.pageNum = 1;
          this.query = {
            "studentName":"",
            "studentIdCardNum":"",
            "enrollmentGrade":"",
            "schoolType":"",
            "deleteReason": ''
          }
          this.getinfo()
      }else if (type == "del"){
        if(this.selectedListid.length==0){
          this.$Message.info("请至少选择一项数据");
          return;
        }else{
          this.delmodel=true
        }
      }
    },
    hidedelmodel(){
      this.delmodel=false
    },
    async handleAllDelete() {
      console.log(this.selectedListid)
      if(this.selectedListid.length==0){
        this.$Message.info("请至少选择一项数据");
        return;
      }else{
        if(this.iseducation){
          if(localStorage["uid"]){
            let url=pseudoDeleteAllInfoList+localStorage["uid"]
            let data=this.selectedListid
            let res = await this.$post(url, data);
            if (res.isSucceed) {
              this.delmodel=false
              this.$Message.success("删除成功");
              this.getinfo()
            }
          }else{
            this.$Message.info("uid过期，请重新登录");
          }
        }else{
          this.$Message.info("您无此权限");
        }
      }
    },
    handleSelect(selection) {
      this.selectedList = [];
      this.selectedListid=[]
      console.log(selection);
      selection.forEach((item) => {
        this.selectedList.push(item.studentName);
        this.selectedListid.push(item.id);
      });
    },
    handleClickDetail(item, type) {
      console.log(item, type);
      if (type == "detail") {
        localStorage.setItem("querydatas",JSON.stringify(this.query))
        let schooltype=''
        if(item.enrollmentGrade=='小一'){
          schooltype=1
        }else if(item.enrollmentGrade=='初一'){
          schooltype=2
        }else if(item.enrollmentGrade=='五升六'||item.enrollmentGrade=='小六'){
          schooltype=3
        }
        this.$router.push({
          name: "newStudentsdetail",
          query: {
            studentId: item.id ,
            schooltype:schooltype,
            page:"pleasedel",
          }
        });
      } else if (type == "del") {
        this.handleDelete(item.id);
      }
    },
    async handleDelete(id) {
      if(this.iseducation){
        if(localStorage["uid"]){
          let url=deleteAllInfoByStudentId+id+"/"+localStorage["uid"]
          let res = await this.$post(url, {});
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            this.getinfo()
          }
        }else{
          this.$Message.info("uid过期，请重新登录");
        }
      }else{
        this.$Message.info("您无此权限");
      }

    },
    pageChange(val) {
      this.pageNum = val;
      this.getinfo()
    },
    async geteducationPermissionCheck(){
      if(localStorage["uid"]){
        let url=educationPermissionCheck+localStorage["uid"]
        let res = await this.$post(url, {});
        console.log(res)
        if (res.isSucceed&&res.code==1) {
          this.iseducation=true
        }else{
          this.iseducation=false
        }
      }else{
        this.$Message.info("uid过期，请重新登录");
      }
    },
    async getinfo(){
      this.isLoading = true;
      this.selectedList=[]
      this.selectedListid=[]
      let url=selectApplicationDeleteInfo
      let newquery={};
      newquery=Object.assign(newquery,this.query)
      if(newquery.enrollmentGrade=="五升六"){
        newquery.enrollmentGrade='小六'
      }
      try {
        let res = await this.$post(url, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...newquery,
        });
        if(res.rows.length>0){
          for(let i=0;i<res.rows.length;i++){
            if(res.rows[i].enrollmentGrade=='小六'){
              res.rows[i].enrollmentGrade='五升六'
            }
          }
        }
        let list = res.rows.map((item) => ({
          ...item,
          schoolType:item.schoolType==2?'民办':'公办'
        }));
        console.log(list);
        this.tableData = list;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    }
  },

  created() {
    if(localStorage["querydatas"]){
      this.query=JSON.parse(localStorage["querydatas"])
      localStorage.removeItem("querydatas")
    }
    this.getinfo()
    this.geteducationPermissionCheck()
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin:0 20px 20px 20px;
}

.search {width: 100%;background-color: white;border-radius: 5px;padding: 20px;margin-bottom: 20px;}
.label {width: 100px;}
.time {width: 100%;}
.bottomtable{width: 100%;padding:20px;}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  // padding: 20px;
  min-height: calc(100vh - 321px);
  .page {width: 100%;padding-bottom:20px;display: flex;justify-content: center;}
  .success {color: #ff7b44;}
  .action {color: #5e6d94;cursor: pointer;margin-right: 10px;}
}
.opens{margin: 0 auto;height:30px;width: 100px;display: flex;justify-content: center;align-items: center;}
.opens span:nth-child(2){margin-left: 40px;color: #666666;}
.openicon{transform: rotate(180deg);}

</style>
